var _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColtPunctat2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 80,
    viewBox: "0 0 116 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 56.25,
    y1: 41,
    x2: 56.25,
    y2: 27,
    stroke: "black",
    strokeWidth: 3.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 56.25,
    y1: 18,
    x2: 56.25,
    y2: 4,
    stroke: "black",
    strokeWidth: 3.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 38.25,
    x2: 80,
    y2: 38.25,
    stroke: "black",
    strokeWidth: 3.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 22.25,
    x2: 80,
    y2: 22.25,
    stroke: "black",
    strokeWidth: 3.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 91,
    y1: 38.25,
    x2: 105,
    y2: 38.25,
    stroke: "black",
    strokeWidth: 3.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 91,
    y1: 22.25,
    x2: 105,
    y2: 22.25,
    stroke: "black",
    strokeWidth: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColtPunctat2);
export default __webpack_public_path__ + "static/media/colt_punctat_2.3277fa5ba4fdf6ffb153f393125a8bcd.svg";
export { ForwardRef as ReactComponent };